// ============================================================================
// src/sheep/sheepRoutes.ts — the sheep domain's route table.
// ============================================================================
// B3.1 finish, second domain. Same shape as src/cattle/cattleRoutes.js: the
// five clauses that were `view === 'X'` tests in resolveSheepEntry are these
// rows, CattleEntry's sibling SheepEntry renders one <AppRoute> per row, and
// the module stays free of view imports so tests and the B2.4 route oracle can
// read it without pulling in the Supabase client.
//
// `paths[0]` is the canonical path the URL↔view effect navigates to. A
// trailing '/*' means the view owns the record space beneath it, and those
// three splats are exactly the prefixes the URL→view adapter in App maps back
// to this view:
//
//   /sheep/flocks/<id>   SheepFlocksView owns the sheep record page
//   /sheep/batches/<id>  SheepBatchesRouter owns the batch record page
//   /sheep/dailys/<id>   SheepDailysView owns the daily record page
//
// '/sheep' and '/sheep/weighins' are exact and must stay exact: a splat on
// '/sheep' would swallow every path above it.
// ============================================================================

export const SHEEP_ROUTES = [
  {view: 'sheepHome', paths: ['/sheep']},
  {view: 'sheepflocks', paths: ['/sheep/flocks/*']},
  {view: 'sheepbatches', paths: ['/sheep/batches/*']},
  {view: 'sheepdailys', paths: ['/sheep/dailys/*']},
  {view: 'sheepweighins', paths: ['/sheep/weighins']},
];
